import firebase from "firebase/app";
import "firebase/firestore";
import "firebase/auth";
import "firebase/storage";
var firebaseConfig = {
    apiKey: process.env.REACT_APP_FIREBASE_apiKey,
    authDomain: "process.env.REACT_APP_FIREBASE_authDomain",
    databaseURL: "process.env.REACT_APP_FIREBASE_databaseURL",
    projectId: process.env.REACT_APP_FIREBASE_projectId,
    storageBucket: process.env.REACT_APP_FIREBASE_storageBucket,
    messagingSenderId: "process.env.REACT_APP_FIREBASE_messagingSenderId",
    appId: "process.env.REACT_APP_FIREBASE_appId",
};

firebase.initializeApp(firebaseConfig);
export default firebase;
